import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { useIsAgencyAdmin } from "@src/hooks/useIsAgencyAdmin";
import { useHasBillableAgencyLink } from "@src/hooks/useHasBillableAgencyLink";

const BILLING_PANEL_EXCLUDED_EMAILS = ["bhavina@intelligems.io"];

export const useShowBillingPanel = () => {
  const isAdmin = useIsAdmin();
  const user = useLoggedInUser();
  const isAgencyUser = useIsAgencyAdmin();

  const hasBillableAgencyLink = useHasBillableAgencyLink();

  const effectiveIsAdmin =
    isAdmin &&
    !BILLING_PANEL_EXCLUDED_EMAILS.includes(user.data?.user?.email ?? "");

  // Admins always see billing; everyone else only if they aren't an agency user
  // and their org isn't a brand under an agency.
  return effectiveIsAdmin || (!isAgencyUser && !hasBillableAgencyLink);
};
